import { QueryString } from "@grandvisionhq/utils";
import { unwrapResponse } from "../../response.js";
import { postJson, acceptJson } from "../../shared.js";
const query = async (apiUrl, request) => {
  const category = request && request.categoryType || void 0;
  const expand = request && request.expand ? request.expand.join("|") : void 0;
  const facets = request && request.facets ? request.facets.join("|") : void 0;
  const filters = request && request.filters ? request.filters.join("|") : void 0;
  const pageIndex = String(request && request.pageIndex || 1);
  const pageSize = String(request && request.pageSize || 24);
  const sortBy = request && request.sortBy || "price";
  const sortDirection = request && request.sortDirection || "asc";
  const queryParams = QueryString.stringify(
    {
      expand,
      filters,
      facets,
      pageIndex,
      pageSize,
      sortBy,
      sortDirection
    },
    true,
    true
  );
  const endpoint = category ? `/category/${category}/` : "/";
  return unwrapResponse(
    await fetch(`${apiUrl}${endpoint}?${queryParams}`, {
      method: "GET",
      headers: {
        ...acceptJson,
        ...postJson
      }
    })
  );
};
export {
  query
};
//# sourceMappingURL=query.js.map
